import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import Back from 'components/Back/Back.jsx'

import { KEY_CODES } from 'constants'

import styles from './ModernizationOverlay.scss'

export class ModernizationOverlay extends React.Component {
    static propTypes = {
        children: PropTypes.object,
    }

    constructor(props) {
        super(props)

        this.state = {
            opened: false,
        }
        this.onKeyUp = this.onKeyUp.bind(this)
    }
    componentWillMount() {
        window.addEventListener('keydown', this.onKeyUp)
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyUp)
    }
    onKeyUp(e) {
        if (e.keyCode === KEY_CODES.ESCAPE && this.state.opened) {
            this.hide()
        }
    }
    show() {
        this.setState({
            opened: true,
        })
    }

    hide() {
        this.setState({
            opened: false,
        })
    }

    render() {
        const handleClose = this.hide.bind(this)

        const className = classNames(styles.base, {
            [styles.base__opened]: this.state.opened,
        })

        return (
            <div className={className}>
                <div className={styles.back}>
                    <Back handleClick={handleClose} />
                </div>
                <div className={styles.content}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default ModernizationOverlay



// WEBPACK FOOTER //
// ./components/ModernizationOverlay/ModernizationOverlay.jsx